export const ROLE_BASE_ANONYMOUS = 'hr.persona.anonymous';
export const ROLE_BASE_USER = 'hr.persona.user';
export const ROLE_BASE_MANAGER = 'hr.persona.manager';
export const ROLE_BASE_ADMIN = 'hr.persona.admin';
export const ROLE_ADMIN_READ_ONLY = 'hr.persona.restricted-admin';
export const ROLE_BASE_ATOB = 'hr.persona.atob';
export const ROLE_EVO_SB_ADMIN = 'service.bureau.admin';
export const ROLE_EVO_SUPER_ADMIN = 'super.admin';
export const ROLE_EVO_GLOBAL_ADMIN = 'global.admin';



// WEBPACK FOOTER //
// ./src/constants/roles.js